<template>
  <div>
    <div class="search-top-row">
      <el-row>
        <!-- 项目 -->
        <el-select v-model="queryParams.applyTypeTemp" size="small" placeholder="选择项目" @change="chooseProject" clearable filterable>
          <el-option v-for="(item, idx) in filterProjectList" :key="idx" :value="item.id" :label="item.name" />
        </el-select>
        <!-- 订单状态 -->
        <el-select v-if="type === 'all'" v-model="queryParams.applyStatusTemp" size="small" placeholder="订单状态" @change="chooseStatus" clearable filterable>
          <el-option v-for="(item, idx) in orderStatus" :key="idx" :value="item.node" :label="item.nodeName" />
        </el-select>
        <!-- 订单子状态 -->
        <el-select
          v-if="type === 'all'"
          v-model="queryParams.applySubStatusTemp"
          size="small"
          placeholder="订单子状态"
          @visible-change="showSubStatus"
          clearable
          filterable
        >
          <el-option v-for="(item, idx) in subOrderStatus" :key="idx" :value="item.node" :label="item.nodeName" />
        </el-select>
        <!-- 审批类型 -->
        <el-select
          v-if="type === 'waitApprove'"
          v-model="queryParams.applyStatusTemp"
          size="small"
          placeholder="审批类型"
          @visible-change="showStatus"
          clearable
          filterable
        >
          <el-option v-for="(item, idx) in approveStatus" :key="idx" :value="item.id" :label="item.name" />
        </el-select>
        <!-- 业务线 -->
        <el-select
          v-if="type === 'waitApprove'"
          v-model="queryParams.clientType"
          size="small"
          placeholder="业务线"
          @visible-change="showStatus"
          clearable
          filterable
        >
          <el-option v-for="(item, idx) in clientTypeList" :key="idx" :value="item.id" :label="item.name" />
        </el-select>
        <!-- 门店状态 -->
        <el-select v-if="isCenterOrder" v-model="queryParams.queryAbiPocStatus" size="small" placeholder="门店状态" clearable filterable>
          <el-option v-for="(item, idx) in pocStatusList" :key="idx" :value="item.id" :label="item.name" />
        </el-select>
        <!-- 提报人角色 -->
        <el-select v-model="queryParams.applyClientLevel" size="small" placeholder="提报人角色" clearable filterable>
          <el-option v-for="(item, idx) in roleList" :key="idx" :value="item.id" :label="item.role" />
        </el-select>
        <!-- 提报人BU -->
        <el-select v-model="queryParams.queryBuCode" size="small" placeholder="提报人BU" clearable filterable @change="buChange">
          <el-option v-for="item in buList" :key="item.orgCode" :value="item.orgCode" :label="item.orgName" />
        </el-select>
        <!-- 提报人Region -->
        <el-select v-model="queryParams.queryRegionCode" size="small" placeholder="提报人Region" clearable filterable>
          <el-option v-for="item in regionList" :key="item.orgCode" :value="item.orgCode" :label="item.orgName" />
        </el-select>
        <el-input class="search-input" v-model="queryParams.keyword" size="small" placeholder="关键字搜索" @keyup.enter.native="handleFilter">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button class="btn-red-plain" size="small" @click="handleFilter">订单搜索</el-button>
        <el-button class="btn-grey-plain" size="small" @click="handleReset">重置</el-button>

        <div class="btn-tool" v-show="type === 'waitApprove' || type === 'waitCheck' || type === 'waitAccept'">
          <div class="btn-check">
            <el-checkbox v-if="showBatchApproval" class="check-box" v-model="checkAll" @change="val => checkChange(val, 1)">全选</el-checkbox>
          </div>
          <div class="btn-batch">
            <el-button v-show="showBatchButton" class="btn-red-plain" size="small" @click="showCheckBox">{{ batchText(type) }}</el-button>
            <el-button
              v-show="type !== 'waitAccept' && showBatchApproval && orderList.length !== 0 && queryParams.applyStatusTemp !== '210'"
              class="btn-red-plain"
              size="small"
              @click="handleBatch('03')"
              >驳回</el-button
            >
            <el-button v-show="showBatchApproval && orderList.length !== 0" class="btn-red" size="small" @click="handleBatch('02')">{{ confirmBtn }}</el-button>
          </div>
        </div>
      </el-row>
    </div>

    <div class="trade-order-list">
      <div class="trade-order-item" v-for="(item, idx) in orderList" :key="idx">
        <order-list-item
          ref="orderItem"
          :info="item"
          :type="type"
          :showBatchApproval="showBatchApproval"
          @infoCheck="infoCheck"
          @handleClick="handleClick"
        ></order-list-item>
      </div>
      <div class="no-data" v-if="orderList.length === 0">暂无数据</div>
    </div>

    <!-- 批量审批弹窗 -->
    <batch-dialog ref="batchDialog" :approvalFormData="approvalFormData" :btnLoading="btnLoading" @handleBatchConfirm="handleBatchConfirm"></batch-dialog>

    <!-- 单独审批弹窗 -->
    <signal-dialog ref="SignalDialog" :approvalFormData="approvalFormData" @handleSuccess="handleFilter"></signal-dialog>

    <!-- 评价弹窗 -->
    <order-comment-dialog ref="OrderCommentDialog" @commentSuccess="commentSuccess" />
  </div>
</template>

<script>
import orderListItem from './order-list-item'
import batchDialog from './batch-dialog'
import SignalDialog from './singal-dialog'
import OrderCommentDialog from './order-comment-dialog'

import { mapGetters } from 'vuex'
import { localStorageUtils } from '@/utils/localstorage'
import { parseTime } from '@/filters'

export default {
  name: 'trade-order-list',
  props: ['orderList', 'type', 'queryParams'],
  components: {
    orderListItem,
    batchDialog,
    SignalDialog,
    OrderCommentDialog
  },
  data () {
    return {
      title: '',
      showBatchApproval: false,
      projectList: [
        { id: '201', name: '门店定制' },
        { id: '202', name: 'Star店招计划' },
        // { id: '101', name: '高端店招' },,
        { id: '102', name: '资产冰柜' },
        // { id: '103', name: '品质堆箱' },
        // { id: '104', name: 'PBO计划' },
        { id: '105', name: '完美门店' },
        // { id: '106', name: 'PBO' },
        // { id: '107', name: '能量包' },
        // { id: '108', name: '夏季能量包' },
        // { id: '109', name: '青柠大行动' },
        { id: '02', name: '批量化物料' },
        { id: '301', name: 'ISP高端执行' },
        { id: '302', name: 'ISP形象店' },
        { id: '303', name: 'ISP物料定制' },
        // { id: '305', name: 'ISP超高端' },
        { id: '111', name: '冰柜转店' },
        { id: '112', name: '冰柜回库' },
        { id: '113', name: '冰柜再投放' },
        // { id: '121', name: '一元换购' },
      ],

      orderStatus: [],
      // roleList: [
      //   { id: '10', role: 'M1' },
      //   { id: '20', role: 'M2' },
      //   { id: '50', role: 'Regional TM' }
      // ],
      approveStatus: [
        { id: '100', name: '需求审批' },
        { id: '200', name: '费用审批' },
        { id: '210', name: '待分配服务商' },
        { id: 'cooler-track', name: '后链路审批' },
      ],
      clientTypeList: [
        { id: '01', name: 'TMKT' },
        { id: '02', name: 'ISP' },
        { id: '03', name: 'KA' }
      ],
      pocStatusList: [
        { id: '4', name: '新增未开业售点' },
        { id: '1', name: '正常营业' },
        { id: '3', name: '临时关店' },
        { id: '2', name: '永久关店' },
      ],
      typeList: [],
      checkedOrderList: [],
      dialogVisible: false,
      confirmBtn: '',
      buList: [],
      regionList: [],
      checkAll: false,
      handleType: '',

      approvalFormData: {
        applyId: '',
        approvalResult: '', // 01提交，02审批通过，03审批退回
        processRemark: '', // 如驳回，驳回理由
        vendorId: '', // 服务商
        processClientId: '', // 操作人Id
        processClientName: '', // 操作人名字
        trCode: '', // TRCode
        quotaId: '', // 配额ID
        ledgerAccount: '', // 总账科目
        companyEntityCode: '',
        costCenterCode: '', // 成本中心
        mmr12: '', // mmr12
        clientType: '', // 用户类型 01百威 02ISP
        applyType: '', // 对应申请单类型 01高端店招 02物料定制 03批量化物料 04品质堆箱
        approvalType: '', // 01需求审批 02费用审批 03验收审批
        tradeApplyExecCoolerList: [], // 资产冰柜
        budgetMonth:parseTime(new Date(),'{y}-{m}')

      },

      applyId: '',
      canSupplier: false,
      canBudget: false,
      handleApproveStatus: '',
      handleApproveType: '',
      isSelectSupplier: false,
      btnLoading: false,
      nodeApplyType: '',
      subOrderStatus: [],
      allOrderStatus: [],
      commentList: [],
      handleVal: null,
      hasUnComment: false,
      projectPermission: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    roleList () {
      let list = []
      if (this.queryParams.applyTypeTemp === '02') {
        list = [
          { id: '10', role: 'M1' },
          { id: '20', role: 'M2' },
          { id: '50', role: 'Regional TM' }
        ]
      } else {
        list = [
          { id: '10', role: 'M1' },
          { id: '20', role: 'M2' }
        ]
      }
      return list
    },

    filterProjectList () {
      let list = this.projectList
      if (!this.projectPermission.lemonStatistics) {
        list = this.projectList.filter((item) => {
          return item.id !== "109"
        })
      }
      if (!this.projectPermission.dcofView) {
        list = this.projectList.filter((item) => {
          return item.id !== "121"
        })
      }

      if(![90, 100].includes(this.userInfo.employeeLevel)) {
        list = this.projectList.filter((item) => {
          return item.id !== "202"
        })
      }
      return list
    },
    isCenterOrder () {
      return !!(this.queryParams.applyTypeTemp && ['102', '105', '111', '112', '113', '201', '302', '303'].includes(this.queryParams.applyTypeTemp))
    },
    // 是否展示批量审批按钮
    showBatchButton(){
      if(this.orderList.length !== 0 && this.type !== 'waitAccept'){
        // 是否只有（star店招）HQTM 方案审批节点
        const isPlan = this.orderList.filter(item =>{
          return item.solutionStatus === '250'
        })
        if(this.userInfo.employeeLevel === 90 && isPlan.length === this.orderList.length){
          return false
        }
      }else{
        return false
      }
      return true
    }
  },
  created () {
    this.getAllRegionList()
    this.employeeLevel = this.userInfo.employeeLevel
    if (
      ((this.employeeLevel === 60 ||
        this.employeeLevel === 70 ||
        this.employeeLevel === 80) &&
        this.userInfo.buCode !== '58') ||
      ((this.employeeLevel === 40 ||
        this.employeeLevel === 45 ||
        this.employeeLevel === 50) &&
        this.userInfo.regionCode !== '286' &&
        this.userInfo.regionCode !== '236')
    ) {
      this.projectList = this.projectList.filter((item) => {
        return item.id !== '106'
      })
    }

    this.projectPermission = JSON.parse(localStorageUtils.get('projectPermission'))
  },
  methods: {
    batchText (type) {
      if (this.showBatchApproval) {
        return '取消'
      }
      if (type === 'waitApprove') {
        this.confirmBtn = '通过'
        return '批量审批'
      }
      if (type === 'waitCheck') {
        this.confirmBtn = '验收'
        return '批量验收'
      }
      if (type === 'waitAccept') {
        this.confirmBtn = '收货'
        return '批量收货'
      }
    },

    /** 获取选中的订单 */
    getCheckedOrder () {
      this.checkedOrderList = []
      this.orderList.forEach((item, index) => {
        if (item.checked) {
          this.checkedOrderList.push(item)
        }
      })
    },

    /** 批量操作 */
    handleBatch (val, hasComment) {
      this.handleVal = val
      this.resetApprovalFormData()
      this.getCheckedOrder()
      if (this.checkedOrderList.length === 0) {
        this.$message.warning('请选择订单')
        return
      }

      let vendorCode = ''

      /**
       * 不同业务线、不同审批类型无法批量审批
       */
      if (this.type === 'waitApprove') {
        let canHandle = true

        for (let i = 0; i < this.checkedOrderList.length - 1; i++) {
          // if (this.checkedOrderList[i].applyType === '04') {
          //   this.$message.error('PBO订单暂不支持批量审批，请筛选其它类型订单')
          //   canHandle = false
          //   break
          // }
          if (
            this.checkedOrderList[i + 1].applyStatus !==
            this.checkedOrderList[0].applyStatus
          ) {
            this.$message.error(
              '不同审批类型的订单无法批量审批，请筛选审批类型相同的订单'
            )
            canHandle = false
            break
          }
          if (
            (this.checkedOrderList[i].solutionStatus === '210' &&
              this.checkedOrderList[i + 1].solutionStatus !== '210') ||
            (this.checkedOrderList[i].solutionStatus !== '210' &&
              this.checkedOrderList[i + 1].solutionStatus === '210')
          ) {
            this.$message.error(
              '不同审批类型的订单无法批量审批，请筛选审批类型相同的订单'
            )
            canHandle = false
            break
          }
          if (
            this.checkedOrderList[i + 1].clientType !==
            this.checkedOrderList[0].clientType
          ) {
            this.$message.error(
              '不同业务线的订单无法批量审批，请筛选业务线相同的订单'
            )
            canHandle = false
            break
          }

          if (this.checkedOrderList[0].vendorCode
            && this.checkedOrderList[i + 1].vendorCode
            && this.checkedOrderList[i + 1].vendorCode !==
            this.checkedOrderList[0].vendorCode
          ) {
            this.$message.error('所选订单存在多个供应商，无法批量审批')
            canHandle = false
            break
          }
        }

        if (!canHandle) {
          return
        }

        if (this.checkedOrderList[0].vendorCode) {
          vendorCode = this.checkedOrderList[0].vendorCode
        }

        this.handleApproveStatus = this.checkedOrderList[0].applyStatus
        this.handleApproveType = this.checkedOrderList[0].applyType

        this.canBudget = false
        this.canSupplier = false
        this.isSelectSupplier = false

        // 选服务商或者预算
        // 门店定制、批量化物料、ISP形象店、ISP物料定制 需选择供应商、预算
        let needSupplier = this.checkedOrderList.findIndex(item => {
          return (item.applyType === '01' && ['201', '202'].includes(item.execList[0].execTypeSub)) || item.applyType === '02' || (item.applyType === '03' && ['302', '303'].includes(item.execList[0].execTypeSub))
        })
        if (needSupplier !== -1) {
          for (let i = 0; i < this.checkedOrderList.length; i++) {
            if (this.handleApproveStatus === '200') {
              if (
                (this.checkedOrderList[i].solutionStatus === '250') ||
                (this.checkedOrderList[i].applyClientLevel === 60 &&
                
                  this.userInfo.employeeLevel === 60 &&
                  this.checkedOrderList[i].solutionStatus === '270')
              ) {
                this.canBudget = true
                this.canSupplier = false
                
                break
              }
              if (this.checkedOrderList[i].solutionStatus === '210') {
                this.canBudget = false
                this.canSupplier = true
                this.isSelectSupplier = true
                break
              }
            } else if (this.handleApproveStatus === '100') {
              if (this.checkedOrderList[i].applyType === '01') {
                if (this.checkedOrderList[i].requirementStatus === '130') {
                  this.canSupplier = true
                  break
                }
              } else if (this.checkedOrderList[i].applyType === '03') {
                if (
                  this.checkedOrderList[i].execList[0].execTypeSub === '303' &&
                  this.checkedOrderList[i].requirementStatus === '140' &&
                  this.userInfo.employeeLevel === 60
                ) {
                  this.canSupplier = true
                  break
                } else if (this.checkedOrderList[i].requirementStatus === '130') {
                  this.canSupplier = true
                  break
                }
              }
            }
          }
        }
      }

      if (this.type === 'waitCheck' && !hasComment) {
        this.hasUnComment = false
        let applyList = []
        this.checkedOrderList.forEach((item) => {
          if (!item.tradeApplyEvaluateDTO) {
            this.hasUnComment = true
            applyList.push(item.applyId)
          }
        })
        if (this.hasUnComment) {
          this.$refs.OrderCommentDialog.commentShow(applyList)
          return
        }
      }

      this.applyId = this.checkedOrderList[0].applyId
      this.handleType = val
      this.$refs.batchDialog.showDialog(
        this.type,
        val,
        this.applyId,
        this.canSupplier,
        this.canBudget,
        vendorCode
      )
    },

    // 单个订单操作
    handleClick (val) {
      if (
        val.orderInfo.acceptanceStatus === '420' &&
        !val.orderInfo.tradeApplyEvaluateDTO
      ) {
        this.hasUnComment = false
        this.handleVal = JSON.parse(JSON.stringify(val))
        if (val.type === '02') {
          this.$refs.OrderCommentDialog.commentShow(val.applyId)
        } else if (val.type === '03') {
          this.commentSuccess()
        }
        return
      }
      this.handleVal = null
      this.resetApprovalFormData()
      this.handleType = val.type

      // 店招，批量化物料收货
      if(val.type === '02' && ['01','02','03'].includes(val.applyType) && val.orderInfo.acceptanceStatus === '450'){
        this.handleReceipt(val.orderInfo.orderId)
        return 
      }

      this.$refs.SignalDialog.dialogShow(
        this.handleType,
        this.type,
        val.applyId,
        val.applyType
      )
    },

    showCheckBox (type) {
      this.showBatchApproval = !this.showBatchApproval
      // 从其他页面返回时，隐藏 checkbox
      if (type === 'tradeOrder') {
        this.showBatchApproval = false
      }
      this.checkAll = false
      this.orderList.forEach((item) => {
        item.checked = false
      })
    },

    chooseProject (val) {
      this.orderStatus = []
      this.queryParams.applyStatusTemp = ''
      this.queryParams.applySubStatusTemp = ''
      this.queryParams.applyClientLevel = ''
      this.showStatus()
    },

    chooseStatus () {
      this.queryParams.applySubStatusTemp = ''
      this.subOrderStatus = []//清除子状态
      this.showStatus()
    },

    showSubStatus () {
      if (this.allOrderStatus.length) {
        this.allOrderStatus.forEach((item) => {
          if (item.node === this.queryParams.applyStatusTemp) {
            this.subOrderStatus = item.subNodeList || []
          }
        })
      }
    },

    showStatus () {
      let listExec = [
        { node: '100', nodeName: '选店审批' },
        { node: '200', nodeName: '方案审批' },
        { node: '300', nodeName: '待完工' },
        { node: '400', nodeName: '待入账' }
      ]

      switch (this.queryParams.applyTypeTemp) {
        case '101':
          this.orderStatus = listExec
          this.nodeApplyType = '01'
          break
        case '201':
          this.orderStatus = listExec
          this.nodeApplyType = '09'
          break
        case '202':
          this.orderStatus = listExec
          this.nodeApplyType = '09'
          break
        case '301':
          this.orderStatus = listExec
          this.nodeApplyType = '05'
          break
        case '302':
          this.orderStatus = listExec
          this.nodeApplyType = '06'
          break
        case '303': {
          this.orderStatus = listExec
          this.nodeApplyType = '07'
          break
        }
        case '305': {
          this.orderStatus = [
            { node: '100', nodeName: '已提交' },
            { node: '300', nodeName: '执行中' }
          ]
          break
        }
        case '102': {
          this.orderStatus = [
            { node: '100', nodeName: '选店审批' },
            { node: '200', nodeName: '支付押金' },
            { node: '300', nodeName: '待发货' },
            { node: '400', nodeName: '待生成台账' },
            { node: '900', nodeName: '已关闭' }
          ]
          this.nodeApplyType = '02'
          break
        }
        case '103': {
          this.orderStatus = [
            { node: '100', nodeName: '售点注册状态' },
            { node: '200', nodeName: '售点执行状态' }
          ]
          this.nodeApplyType = '03'
          break
        }
        case '104': {
          this.orderStatus = [
            { node: '100', nodeName: '审核状态' },
            { node: '300', nodeName: '售点执行阶段' }
          ]
          this.nodeApplyType = '104'
          break
        }
        case '105': {
          this.orderStatus = [
            { node: '100', nodeName: '活动审核状态' },
            { node: '300', nodeName: '活动执行阶段' },
            { node: '900', nodeName: '已关闭' }
          ]
          this.nodeApplyType = '105'
          break
        }
        case '106': {
          this.orderStatus = [
            { node: '100', nodeName: '售点注册状态' },
            { node: '200', nodeName: '售点执行状态' }
          ]
          this.nodeApplyType = '03'
          break
        }
        case '107': {
          this.orderStatus = [
            { node: '100', nodeName: '已提交' },
            { node: '300', nodeName: '执行中' }
          ]
          break
        }
        case '108': {
          this.orderStatus = [
            { node: '100', nodeName: '已提交' },
            { node: '300', nodeName: '执行中' }
          ]
          break
        }
        case '109': {
          this.orderStatus = [
            { node: '0', nodeName: '待提交' },
            { node: '100', nodeName: '活动审批' },
            { node: '300', nodeName: '活动执行' },
            { node: '500', nodeName: '已完成' }
          ]
          break
        }
        case '111':
          this.orderStatus = listExec
          break
        case '113':
          this.orderStatus = listExec
          break
        case '02': {
          this.orderStatus = [
            { node: '200', nodeName: '方案审批' },
            { node: '300', nodeName: '待完工' },
            { node: '400', nodeName: '待入账' }
          ]
          this.nodeApplyType = '04'
          break
        }
      }

      if (this.orderStatus.length) {
        if (
          this.orderStatus[this.orderStatus.length - 1].node !== '500' &&
          this.queryParams.applyTypeTemp !== '104'
        ) {
          this.orderStatus.push({ node: '500', nodeName: '已完成' })
        }
      }

      if (!this.nodeApplyType) {
        return
      }
      this.$store
        .dispatch('getNodeList', { type: this.nodeApplyType })
        .then((res) => {
          if (res.data.resultCode === '0') {
            this.allOrderStatus = res.data.resultData.orderStatusNodeList || []
            this.showSubStatus()
          }
        })
    },

    // 获取BU-region列表
    getAllRegionList () {
      this.$store.dispatch('getAllRegionList').then((res) => {
        if (res.data.resultCode === '0') {
          this.buList = res.data.resultData.voList || []
        }
      })
    },

    // 选择BU
    buChange (val) {
      if (!val) {
        return
      }
      this.regionList = []
      this.queryParams.queryRegionCode = ''
      this.queryParams.reportRegion = ''
      this.buList.forEach((item) => {
        if (item.orgCode === val) {
          this.regionList = item.subOrgList || []
        }
      })
    },

    /** 根据条件筛选订单 */
    handleFilter () {
      this.queryParams.page = 1
      this.queryParams.queryType = ''
      this.queryParams.execTypeSubList = ''
      this.$emit('handleFilter')
    },

    // 搜索重置
    handleReset () {
      this.queryParams.execTypeSubList = ''
      this.queryParams.applyTypeTemp = ''
      this.queryParams.applyStatus = ''
      this.queryParams.applyStatusList = ''
      this.queryParams.applyClientLevel = ''
      this.queryParams.queryBuCode = ''
      this.queryParams.queryRegionCode = ''
      this.queryParams.keyword = ''
      this.queryParams.clientType = ''
      this.queryParams.applyStatusTemp = ''
      this.queryParams.applySubStatusTemp = ''
      this.queryParams.queryType = ''
      this.queryParams.sievingDisablePoc = ''
      this.queryParams.queryAbiPocStatus = ''
      this.orderStatus = []
      this.subOrderStatus = []
      this.handleFilter()
    },

    // 是否全选
    checkChange (val, type) {
      this.checkAll = val
      if (type) {
        this.orderList.forEach((item) => {
          if (item.applyType !== '04') {
            item.checked = val
          }
        })
      }
    },

    infoCheck () {
      let allChecked = true
      this.orderList.forEach((item) => {
        if (!item.checked) {
          allChecked = false
        }
      })
      this.checkChange(allChecked, 0)
    },

    resetApprovalFormData () {
      this.approvalFormData = {
        applyId: '',
        approvalResult: '', // 01提交，02审批通过，03审批退回
        processRemark: '', // 如驳回，驳回理由
        vendorId: '', // 服务商
        processClientId: '', // 操作人Id
        processClientName: '', // 操作人名字
        trCode: '', // TRCode
        quotaId: '', // 配额ID
        ledgerAccount: '', // 总账科目
        costCenterCode: '', // 成本中心
        mmr12: '', // mmr12
        clientType: '', // 用户类型 01百威 02ISP
        applyType: '', // 对应申请单类型 01高端店招 02物料定制 03批量化物料 04品质堆箱
        approvalType: '', // 01需求审批 02费用审批 03验收审批
        tradeApplyExecCoolerList: [], // 资产冰柜
        budgetMonth:parseTime(new Date(),'{y}-{m}')
      }
    },

    // 弹窗确认
    handleBatchConfirm () {
      if (this.btnLoading) {
        return
      }

      let params = [] // 百威
      let ispParams = [] // isp
      let successText = ''

      // 批量驳回
      if (this.handleType === '03') {
        if (!this.approvalFormData.processRemark) {
          this.$message.error('请填写驳回理由')
          return
        }
        successText = '批量驳回成功'
        this.checkedOrderList.forEach((item) => {
          if (item.applyType !== '03') {
            params.push({
              applyId: item.applyId,
              approvalResult: '03', // 01提交，02审批通过，03审批退回
              approvalType: this.setApproveType(item.applyStatus), // 01需求审批 02费用审批 03验收审批
              processClientId: this.userInfo.clientId,
              processClientName: this.userInfo.clientName,
              processRemark: this.approvalFormData.processRemark
            })
          } else {
            ispParams.push({
              applyId: item.applyId,
              approvalResult: '03', // 01提交，02审批通过，03审批退回
              approvalType: this.setApproveType(item.applyStatus), // 01需求审批 02费用审批 03验收审批
              processClientId: this.userInfo.clientId,
              processClientName: this.userInfo.clientName,
              processRemark: this.approvalFormData.processRemark
            })
          }
        })
      } else if (this.handleType === '02') {
        // 批量审批
        if (this.type === 'waitApprove') {
          successText = '批量审批成功'

          // 是否需要选供应商
          if (
            this.canSupplier &&
            !this.approvalFormData.vendorId &&
            (this.handleApproveStatus === '200' ||
              (this.handleApproveType === '03' &&
                this.handleApproveStatus === '100'))
          ) {
            this.$message.error('请选择服务商')
            return
          }

          // 是否需要选预算
          if (this.canBudget) {
            if (
              !this.approvalFormData.trCode
            ) {
              this.$message.error('请选择预算')
              return
            }
            if (!this.approvalFormData.mmr12) {
              this.$message.error('请选择MMR12')
              return
            }
            if (!this.approvalFormData.companyEntityCode) {
              this.$message.error('请选择所属工厂')
              return
            }
            if (!this.approvalFormData.costCenterCode) {
              this.$message.error('请选择成本中心')
              return
            }
            if (!this.approvalFormData.ledgerAccount) {
              this.$message.error('请选择总账科目')
              return
            }
            if (!this.approvalFormData.budgetMonth) {
              this.$message.error('请选择业务月份')
              return
            }
          }


          this.checkedOrderList.forEach((item) => {
            this.approvalFormData.tradeApplyExecCoolerList = []
            if (item.applyType !== '03') {
              if (item.execList && item.execList.length) {
                item.execList.forEach((list) => {
                  if (list.execTypeSub === '102') {
                    // 资产冰柜
                  }
                })
              }
              params.push({
                applyId: item.applyId,
                approvalResult: '02', // 01提交，02审批通过，03审批退回
                approvalType: this.setApproveType(item.applyStatus), // 01需求审批 02费用审批 03验收审批
                processClientId: this.userInfo.clientId,
                processClientName: this.userInfo.clientName,
                processRemark: this.approvalFormData.processRemark,
                vendorId: this.approvalFormData.vendorId,
                trCode: this.approvalFormData.trCode,
                quotaId: this.approvalFormData.quotaId,
                mmr12: this.approvalFormData.mmr12,
                companyEntityCode: this.approvalFormData.companyEntityCode,
                costCenterCode: this.approvalFormData.costCenterCode,
                ledgerAccount: this.approvalFormData.ledgerAccount,
                tradeApplyExecCoolerList:
                  this.approvalFormData.tradeApplyExecCoolerList,
                  budgetMonth: this.approvalFormData.budgetMonth
              })
            } else {
              ispParams.push({
                applyId: item.applyId,
                approvalResult: '02', // 01提交，02审批通过，03审批退回
                approvalType: this.setApproveType(item.applyStatus), // 01需求审批 02费用审批 03验收审批
                processClientId: this.userInfo.clientId,
                processClientName: this.userInfo.clientName,
                processRemark: this.approvalFormData.processRemark,
                vendorId: this.approvalFormData.vendorId,
                trCode: this.approvalFormData.trCode,
                quotaId: this.approvalFormData.quotaId,
                mmr12: this.approvalFormData.mmr12,
                companyEntityCode: this.approvalFormData.companyEntityCode,
                costCenterCode: this.approvalFormData.costCenterCode,
                ledgerAccount: this.approvalFormData.ledgerAccount,
                budgetMonth: this.approvalFormData.budgetMonth
              })
            }
          })
        }

        // 批量验收
        if (this.type === 'waitCheck') {
          successText = '批量验收成功'

          this.checkedOrderList.forEach((item) => {
            if (item.applyType !== '03') {
              params.push({
                applyId: item.applyId,
                approvalResult: '02', // 01提交，02审批通过，03审批退回
                approvalType: '03', // 01需求审批 02费用审批 03验收审批
                processClientId: this.userInfo.clientId,
                processClientName: this.userInfo.clientName,
                processRemark: this.approvalFormData.processRemark
              })
            } else {
              ispParams.push({
                applyId: item.applyId,
                approvalResult: '02', // 01提交，02审批通过，03审批退回
                approvalType: '03', // 01需求审批 02费用审批 03验收审批
                processClientId: this.userInfo.clientId,
                processClientName: this.userInfo.clientName,
                processRemark: this.approvalFormData.processRemark
              })
            }
          })
        }

        // 批量收货
        if (this.type === 'waitAccept') {
          this.checkedOrderList.forEach((item) => {
            params.push({
              applyId: item.applyId
            })
          })
          this.btnLoading = true
          this.$store
            .dispatch('batchAccept', params)
            .then((res) => {
              this.btnLoading = false
              if (res.data.resultCode === '0') {
                this.$message.success('批量收货成功')
                this.$refs.batchDialog.closeDialog()
                this.handleFilter()
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
          return
        }
      }

      if (params.length) {
        if (this.isSelectSupplier) {
          // 批量提交服务商
          this.btnLoading = true
          this.$store
            .dispatch('bathSubmitSupplier', params)
            .then((res) => {
              this.btnLoading = false
              if (res.data.resultCode === '0') {
                if (res.data.resultData?.errMsg) {
                  this.$alert(`${res.data.resultData.errMsg}`, '提示', {
                    customClass: 'custom-message-box',
                    confirmButtonText: '好的',
                    confirmButtonClass: 'custom-message-box-confirm-btn',
                    callback: action => {

                    }
                  })
                } else {
                  this.$message.success('批量分配服务商成功')
                }
                this.$refs.batchDialog.closeDialog()
                this.handleFilter()
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else {
          this.btnLoading = true
          this.$store
            .dispatch('batchApproval', params)
            .then((res) => {
              this.btnLoading = false
              if (res.data.resultCode === '0') {
                if (res.data.resultData?.errMsg) {
                  this.$alert(`${res.data.resultData.errMsg}`, '提示', {
                    customClass: 'custom-message-box',
                    confirmButtonText: '好的',
                    confirmButtonClass: 'custom-message-box-confirm-btn',
                    callback: action => {

                    }
                  })
                } else {
                  this.$message.success(successText)
                }
              }
              this.$refs.batchDialog.closeDialog()
              this.handleFilter()
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      }
      if (ispParams.length) {
        this.btnLoading = true
        this.$store
          .dispatch('bathIspApproval', ispParams)
          .then((res) => {
            this.btnLoading = false
            if (res.data.resultCode === '0') {
              if (res.data.resultData?.errMsg) {
                this.$alert(`${res.data.resultData.errMsg}`, '提示', {
                  confirmButtonText: '好的',
                  confirmButtonClass: 'recharge-dealer-alert-btn',
                  customClass: 'recharge-dealer-message',
                  callback: action => {

                  }
                })
              } else {
                this.$message.success(successText)
              }
            }
            this.$refs.batchDialog.closeDialog()
            this.handleFilter()
          })
          .catch(() => {
            this.btnLoading = false
          })
      }
    },

    // 获取审批类型
    setApproveType (val) {
      let approvalType = ''
      if (val === '100') approvalType = '01'
      if (val === '200') approvalType = '02'
      if (val === '400') approvalType = '03'
      return approvalType
    },

    setLoading (val) {
      this.$emit('setLoading', val)
    },

    // 评价成功
    commentSuccess () {
      if (!this.hasUnComment) {
        this.handleVal.orderInfo.tradeApplyEvaluateDTO = {}
        this.handleClick(this.handleVal)
      } else {
        this.handleBatch(this.handleVal, true)
      }
      this.handleFilter()
    },

    // 确认收货
    handleReceipt(orderId) {
      const inUse = ['prod', 'test', 'dev'].includes(process.env.VUE_APP_ENV)
      if (!inUse) {
        return this.$notify({
          title: '提示',
          message: '暂未开放，敬请期待',
          type: 'warning',
        })
      }

      const token = localStorageUtils.get('eb-token')
      const urlMap = {
        dev: 'https://icircle-dev.abipocm.com/login-auto',
        test: 'https://icircle-test.abipocm.com/login-auto',
        prod: 'https://icircle.abipocm.com/login-auto'
      }
      let url = urlMap[process.env.VUE_APP_ENV]
      if (!url) {
        return
      }
      if(!orderId){
        this.$message.error('缺少orderId')
        return 
      }
      const targetUri = `/order/info?orderId=${orderId}`
      // window.open(`${url}?token=${token}&targetUri=${targetUri}`, '_blank')
      window.location.href = `${url}?token=${token}&targetUri=${targetUri}`
    },
  }
}
</script>

<style lang="scss" scoped>
.margin-bottom-10 {
  margin-bottom: 10px;
}
.margin-top-15 {
  margin-top: 15px;
}
.btn {
  width: 100px;
  height: 30px;
  padding: 0;
  text-align: center;
  border-radius: 50px;
  line-height: 5px;
}
.btn-tool {
  display: flex;
  width: 100%;
  height: 30px;
  margin: 5px auto -10px 0;
  justify-content: space-between;
  align-items: center;

  .btn-check {
    margin-left: -40px;

    .check-box {
      zoom: 140%;

      ::v-deep .el-checkbox__label {
        zoom: 80%;
      }
    }

    ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
      color: $base-red;
    }
  }
}
.search-input.el-input {
  width: 200px;
  height: 36px;
  margin: 0 20px 20px 0;
  input::-webkit-input-placeholder {
    color: #000;
  }
}
.el-select {
  width: 150px;
  height: 36px;
  margin: 0 15px 10px 0;
}

.trade-order-list {
  width: 100%;
  height: auto;
  padding-left: 60px;
  margin-top: 20px;
  box-sizing: border-box;
  .trade-order-item {
    width: 100%;
    min-height: 150px;
    margin: 15px 0;
    // padding: 15px 25px;
    border-radius: 10px;
    background-color: $base-white;
    box-sizing: border-box;
  }
  .no-data {
    text-align: center;
  }
}

.search-top-row {
  margin-left: 60px;
}
</style>
